import React from 'react';
import { Button, ButtonPriority as PRIORITY } from 'wix-ui-tpa/cssVars';
import { SlimArrowDownIcon } from '../../../icons/slim-arrow-icon';
import { st, classes } from './submit-button.st.css';
const SubmitButton = ({ children, disabled, onClick, className, ...rest }) => (React.createElement(Button, { className: st(classes.root, className), disabled: disabled, priority: PRIORITY.primary, onClick: disabled ? undefined : onClick, upgrade: true, ...rest },
    React.createElement("div", { className: classes.buttonContent },
        children,
        React.createElement(SlimArrowDownIcon, { className: classes.icon }))));
export default SubmitButton;
//# sourceMappingURL=submit-button.js.map